<template>
	<div class="template-box">
		<div class="page-title">订单详情</div>
		<div class="loading-box" v-if="loading">
			<van-loading size="24px" color="#1989fa">加载中...</van-loading>
		</div>
		<template v-if="!loading">
			<!-- 订单信息 -->
			<div class="card-box">
				<div class="card-title-box">订单信息</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">订单号</div>
						<div class="card-content-item-left">
							{{ orderDetail.order_no }}
						</div>
					</div>
				</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">订单金额</div>
						<div class="card-content-item-left">{{ orderDetail.total_price }} 元</div>
					</div>
				</div>
        <div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">下单时间</div>
						<div class="card-content-item-left">{{ orderDetail.create_time }}</div>
					</div>
				</div>
        <div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">订单来源</div>
						<div class="card-content-item-left">
							{{ orderDetail.subject }}
						</div>
					</div>
				</div>
        <div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">业务类型</div>
						<div class="card-content-item-left">创新空间</div>
					</div>
				</div>
        <div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">预定时间</div>
						<div class="card-content-item-left">
							<div v-for="item in orderDetailList.book_time" :key="item.invoiceConfigId">
								{{ item }}
							</div>
						</div>
					</div>
				</div>
        <div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">会议地点</div>
						<div class="card-content-item-left">{{ orderDetailList.address }}</div>
					</div>
				</div>
			</div>
      <!-- 配套服务 -->
			<div class="card-box">
				<div class="card-title-box">配套服务</div>
        <div class="card-content-box">
					<div class="card-content-item" v-for="item in orderDetailList.details_of_service_charges" :key="item.id">
						<div class="card-content-item-right">{{item.itemName}}(元)</div>
						<div class="card-content-item-left">{{ item.price  }}</div>
					</div>
				</div>
			</div>
      <!-- 联系人信息 -->
			<div class="card-box">
				<div class="card-title-box">联系人信息</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">联系人姓名</div>
						<div class="card-content-item-left">
							{{ orderDetail.customer_name }}
						</div>
					</div>
				</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">联系人电话</div>
						<div class="card-content-item-left">{{ orderDetail.customer_phone }}</div>
					</div>
				</div>
        <div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">机构名称</div>
						<div class="card-content-item-left">{{ orderDetail.zz_customer_name }}</div>
					</div>
				</div>
			</div>
      <!-- 收费明细 -->
			<div class="card-box">
				<div class="card-title-box">收费明细</div>
        <div class="card-content-box">
					<div class="card-content-item" v-for="item in orderDetailList.order_fee_info" :key="item.id">
						<div class="card-content-item-right">{{ !item.materiName  ? '租赁押金' : item.materiName }}(元)</div> 
						<div class="card-content-item-left">{{ item.price  }}</div>
					</div>
				</div>
			</div>
      <!-- 退款明细 -->
			<div class="card-box">
				<div class="card-title-box">退款明细</div>
        <div class="card-content-box">

          <div class="card-content-item" v-if="cxkjFee.materiName">
						<div class="card-content-item-right">{{ cxkjFee.materiName }}(元)</div> 
						<div class="card-content-item-left">{{ cxkjFee.price - orderTransferList.product_fee }}</div>
					</div>
          <div class="card-content-item" v-if="serviceFee.materiName">
						<div class="card-content-item-right">{{ serviceFee.materiName }}(元)</div> 
						<div class="card-content-item-left">{{ serviceFee.price - orderTransferList.service_fee }}</div>
					</div>
          <div class="card-content-item">
						<div class="card-content-item-right">租赁押金(元)</div> 
						<div class="card-content-item-left">{{ depositFee.price - orderTransferList.deposit_fee }}</div>
					</div>
				</div>
			</div>
			<!-- 支付详情 -->
			<!-- <div class="card-box">
				<div class="card-title-box">支付详情</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">缴费方式</div>
						<div class="card-content-item-left">{{ orderDetail.channel }}</div>
					</div>
				</div>
        <div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">支付时间</div>
						<div class="card-content-item-left">{{ orderDetail.pay_time }}</div>
					</div>
				</div>
			</div> -->
      <!-- 转款明细 -->
      <div class="card-box" v-if="orderTransferList.deposit_fee !== 0">
				<div class="card-title-box">转款明细</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">{{ orderTransferList.materi_name }}</div>
						<div class="card-content-item-left">{{ orderTransferList.deposit_fee }}</div>
					</div>
				</div>
      </div>
      <!-- 转账信息 -->
			<div class="card-box" v-if="orderTransferList.bank_account">
				<div class="card-title-box">转账信息</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">银行账号</div>
						<div class="card-content-item-left">{{ orderTransferList.bank_account }}</div>
					</div>
				</div>
        <div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">开户行</div>
						<div class="card-content-item-left">{{ orderTransferList.bank_name }}</div>
					</div>
				</div>
        <div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">联行号</div>
						<div class="card-content-item-left">{{ orderTransferList.lines_no }}</div>
					</div>
				</div>
			</div>
      <!-- 备注 -->
      <div class="card-box">
				<div class="card-title-box">备注</div>
				<div class="card-content-box">
					<div class="card-content-item">
						<div class="card-content-item-right">{{ orderDetail.deduct_reason }}</div>
					</div>
				</div>
      </div>
      <!-- 附件 -->
      <div class="card-box">
				<div class="card-title-box">附件</div>
				<div class="card-content-box">
					<div class="card-content-item" v-if="orderTransferList.bank_account">
						<div class="card-content-item-right" style="width:100%">
              <div v-for="item in orderDetail.attaches" :key="item.id">
								<a :href='item.attach_url'>{{item.attach_name}}</a>
							</div>
            </div>
					</div>
				</div>
      </div>
		</template>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	data() {
		return {
			orderDetail: {},
      orderDetailList: {},
      orderTransferList: {},
			loading: false,
      checkPayType: {
        WXPAY: '微信',
        ALIPAY: '支付宝',
        ZZPAY: '转账',
		},
      cxkjFee: {},
      serviceFee: {},
      depositFee: {}
		}
	},
	mounted() {
		this.getData()
	},
	methods: {
		// 获取详情信息
		getData() {
			let self = this
			let orderNo = this.$route.query.orderId
			self.loading = true
			self.vaxios.get(`${self.vaxios.host}/open/api/v1/communities/refund/${orderNo}/detail`, { orderNo }, (res) => {
				if (res === -1 || !res.data) {
					self.$toast.fail({ duration: 0, message: '获取信息失败,请重新扫码！' })
					return
				}
				self.orderDetail = res.data
        self.orderDetailList = res.data.detail
        self.orderTransferList = res.data.return_detail
        self.orderDetail.channel = self.checkPayType[res.data.channel] || ''
        self.orderDetail.pay_time = self.checkDate(res.data.pay_time)
        self.orderDetail.create_time = self.checkDate(res.data.create_time)
        self.cxkjFee = self.orderDetailList?.order_fee_info?.find((i)=> 
          i.type === 1
        ) || {}
        self.serviceFee = self.orderDetailList?.order_fee_info?.find((i)=> 
          i.type === 2
        ) || {}
        self.depositFee = self.orderDetailList?.order_fee_info?.find((i)=> 
          i.type === 3
        ) || {}
				self.loading = false
			})
		},
    // 时间格式
		checkDate(value) {
			return value ? moment(new Date(parseInt(value))).format('YYYY-MM-DD HH:mm:ss') : ''
		}
	},
}
</script>

<style scoped lang="scss">
.template-box {
	background: #f7f4f8;
	// height: 100%;
}
.page-title {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	background-color: #fff;
	font-weight: 500;
	font-size: 18px;
}
.card-box {
	background-color: #fff;
	margin: 10px;
	padding: 10px 10px 0 10px;
	.card-title-box {
		font-size: 18px;
		font-weight: 500;
		padding-bottom: 10px;
		border-bottom: 1px solid #f4f4f4;
	}
	.card-content-box {
		padding: 10px 0;
		display: flex;
		flex-direction: column;
		.card-content-item {
			display: flex;
			padding-bottom: 10px;
      // justify-content: space-between;
		}
		.card-content-item-left {
			font-size: 14px;
      margin-left: 70px;
		}
		.card-content-item-right {
			color: #999;
			font-size: 14px;
			width: 100px;
			flex-shrink: 0;
		}
	}
	.total-price-box {
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		.total-price-title {
			color: #999;
			font-size: 14px;
			padding-right: 10px;
		}
		.total-price-price {
			font-weight: 600;
			color: #e98c70;
		}
	}
	.pay-content-right {
		display: flex;
		color: #999;
		font-size: 14px;
		align-items: center;
		.wxpay-img {
			width: 35px;
			height: 35px;
		}
	}
}
.pay-text-box {
	margin: 10px;
	padding: 10px 0;
	display: flex;
	flex-direction: column;
	font-size: 14px;
	color: #999;
}
.loading-box {
	display: flex;
	align-items: center;
	justify-content: center;
}
.card-order {
	color: red;
	text-align: center;
	padding-bottom: 10px;
}
</style>
